/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactElement, useEffect, useState, useRef, memo } from 'react'
import Globe, { GlobeMethods } from 'react-globe.gl'

import { ASSETS, SERVED_COUNTRIES } from '../../../constants'

import './index.css'

const AboutGlobe: FC = (): ReactElement => {
  const globeEl = useRef<GlobeMethods | any>(null)
  const [countries, setCountries] = useState({ features: [] })

  useEffect(() => {
    // Auto-rotate
    fetch('./aboutGlobe.geojson')
      .then((res) => res.json())
      .then(setCountries)
    if (globeEl?.current) {
      globeEl.current.controls().autoRotate = true
      globeEl.current.controls().autoRotateSpeed = 0.5
      globeEl.current.controls().enableZoom = false
    }
  }, [])

  const globeHeight = window.innerWidth > 500 ? 800 : window.innerHeight * 0.7
  return (
    <div>
      <Globe
        ref={globeEl}
        width={globeHeight}
        height={globeHeight}
        hexPolygonsData={countries.features}
        globeImageUrl={`${ASSETS}/pages/about/earth-blue.png`}
        hexPolygonResolution={3}
        hexPolygonMargin={0.3}
        backgroundColor="rgba(0,0,0,0)"
        hexPolygonColor={(a: any): string => {
          if (SERVED_COUNTRIES.some((c) => a.properties?.ADMIN.toLowerCase().includes(c.Country.toLowerCase()))) {
            return '#fff'
          }
          return 'rgba(0,0,0,0)'
        }}
        hexPolygonLabel={(a: any): string => {
          const d = a.properties
          return `
            <b class="globe-hex-label">${d.ADMIN} (${d.ADM0_A3})</b> <br />
          `
        }}
        onHexPolygonHover={(hex: any) => {
          if (globeEl.current) {
            globeEl.current.controls().autoRotate = !hex
          }
        }}
      />
    </div>
  )
}

export default memo(AboutGlobe)
